// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.emd-tippy-ghost {\r\n  cursor: pointer !important;\n}\n.emd-tippy-ghost._no-wrap + div[data-tippy-root] {\r\n  white-space: nowrap;\n}\r\n", ""]);
// Exports
module.exports = exports;
